import { Box } from '@amzn/awsui-components-console';

/**
 * Contains a widget within a description list.
 * @param title - the title of the widget
 * @param className - styles to apply to the description list
 * @param children - children elements which will be list items
 */
const WidgetContainer = ({ title, children }) => {
    return (
        <>
            <Box variant='awsui-key-label'>{title}</Box>
            <Box margin={{ left: 'm' }}>{children}</Box>
        </>
    );
};

export default WidgetContainer;
